import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  APPROVAL_TABLE_HEAD_BG,
  approvalFormTableStyles,
} from '@/components/Approval/@components/ApprovalFormTable/styles';

/** V2 카드·레거시 문서 카드 모두 태그·클래스로 스타일링 */
export const ClaimNoteRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': { ...approvalFormTableStyles(theme), minWidth: 800 },
  // 카드 사이 간격 — 레거시 문서 카드도 맨 위 div
  '& > div + div': { marginTop: 16 },
  '& .text-center': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  '& th.bg-info': { fontWeight: 600 },
  '& .bg-title, & .bg-title > *, & .textBold': {
    textAlign: 'center',
    fontWeight: 600,
  },
  '& .bg-title > *, & td.bg-title, & .bg-success, & .bg-warning': {
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
  },
}));
